<template>
	<v-container>
		<v-row class="contentRow">
			<v-col>
				<h1 class="mb-2">Requested Connections List</h1>
				<p class="mb-10 text-center">
					This is a list of connections other companies have requested with you.
					<br />Accepting a request will allow the other company to see your name and send you transactions.
				</p>
				<v-data-table :loading="loading" theme-- light :headers="headers" :items="incomingrequests"
					:items-per-page="5" :footer-props="{
						'items-per-page-options': [5, 10, 15]
					}" class="light table">
					<template v-slot:item.avatar="{ item }">
						<v-avatar color="primary" size="40">
							<v-img v-if="item.CompanyLogo" :src="item.CompanyLogo" alt="Company Logo"></v-img>
							<span v-else class="white--text">{{ item.name.charAt(0) }}</span>
						</v-avatar>
					</template>
					<template v-slot:item.clientID="{ item }">
						<td style="text-align: center; padding-right: 80px;">
							<span >{{ item.clientID }}</span>
						</td>
					</template>
					<template v-slot:item.remove="{ item }">
						<v-btn color="success" v-on:click="acceptRequest(item)">
							<v-icon color="white" small>fas fa-check</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<v-row class="contentRow">
			<v-col>
				<h1 class="mb-2">Pending Connections List</h1>
				<p class="mb-10 text-center">This is a list of connections you have requested with other companies.</p>
				<v-data-table :loading="loading" theme-- light :headers="outgoingHeaders" :items="outgoingrequests"
					:items-per-page="5" :footer-props="{
						'items-per-page-options': [5, 10, 15]
					}" class="light table">
					<template v-slot:item.avatar="{ item }">
						<v-avatar color="primary" size="40">
							<v-img v-if="item.CompanyLogo" :src="item.CompanyLogo" alt="Company Logo"></v-img>
							<span v-else class="white--text">{{ item.name.charAt(0) }}</span>
						</v-avatar>
					</template>
					<template v-slot:item.clientID="{ item }">
					<td style="text-align: center; padding-right: 50px;">
						<span >{{ item.clientID }}</span>
					</td>
				</template>
					<template v-slot:item.remove="{ item }">
						<v-btn color="red" dark v-on:click="showDeleteDialog(item)">
							Cancel request<v-icon color="white" small right>fas fa-times</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<v-form ref="form" v-model="formIsValid">
			<v-row class="contentRow">
				<v-col cols="4">
					<h2 class="text-start">Request Connection</h2>
				</v-col>
				<v-col cols="4">
					<v-text-field label="Client ID" :rules="notEmptyRule" v-model="clientID" outlined></v-text-field>
				</v-col>
				<v-col cols="4">
					<v-btn x-large color="success" :disabled="!formIsValid" v-on:click="addConnection" outlined>Add
						Connection</v-btn>
				</v-col>
			</v-row>
		</v-form>
		<v-form ref="form2" v-model="codeIsValid">
			<v-row class="contentRow">
				<v-col cols="4">
					<h2 class="text-start">Add Connection From Invitation Code</h2>
				</v-col>
				<v-col cols="4">
					<v-text-field label="Invitation Code" :rules="notEmptyRule" v-model="invitationCode"
						outlined></v-text-field>
				</v-col>
				<v-col cols="4">
					<v-btn x-large color="success" :disabled="!codeIsValid" v-on:click="redeemCode" outlined>Redeem
						Code</v-btn>
				</v-col>
			</v-row>
		</v-form>
		<v-dialog v-model="loading" hide-overlay persistent width="300">
			<v-card color="primary" dark>
				<v-card-text>
					<p class="pt-3">Please stand by</p>
					<v-progress-linear indeterminate color="white" class="mb-0 mt-3"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDelete" max-width="500px">
			<v-card>
				<v-card-title>Are you sure you want to remove this connection?</v-card-title>
				<v-card-text>Once it is removed, you must send a new request to create a connection</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
					<v-btn color="error" text @click="removeRow">Delete</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>


<script>
import ConnectionsAPI from "../../api/connections/connection"
import LoadingState from "../../consts/LoadingState"
import { mapState } from "vuex"
import InvitationCodesAPI from "../../api/connections/invitationcodes"
export default {
	name: "ConnectionRequests",
	props: ["selected"],
	data() {
		return {
			headers: [
				{ text: "", value: "avatar", sortable: false, width: "5%", },
				{ text: "Client Name", value: "name", sortable: false },
				{ text: "Client ID", value: "clientID", sortable: false },
				{ text: "Email", value: "Email", sortable: false },
				{ text: "Actions", value: "remove", sortable: false }
			],
			outgoingHeaders: [
				{ text: "", value: "avatar", sortable: false, width: "5%", },
				{ text: "Client Name", value: "name", sortable: false },
				{ text: "Client ID", value: "clientID", sortable: false },
				{ text: "Email", value: "Email", sortable: false },
				{ text: "Actions", value: "remove", sortable: false }
			],
			incomingrequests: [],
			outgoingrequests: [],
			clientID: null,
			invitationCode: null,
			formIsValid: false,
			codeIsValid: false,
			notEmptyRule: [v => !!v || "This field is required"],
			dialogDelete: false,
			itemToDelete: null
		}
	},
	mounted() {
		this.loadIncomingItems()
		this.loadOutgoingItems()
	},
	methods: {
		loadOutgoingItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Getting Connections...",
				{ root: true }
			)
			ConnectionsAPI.getOutgoingConnections()
				.then(result => {

					this.outgoingrequests = []
					for (let entry of result) {
						this.outgoingrequests.push({
							clientID: entry.clientID,
							CompanyLogo: entry.CompanyLogo,
							name: entry.name,
							Email: entry.Email,
							remove: null
						})
					}
					if (this.$store.state.loading.loading == LoadingState.LOADING)
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							null,
							{ root: true }
						)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadIncomingItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Getting Connections...",
				{ root: true }
			)
			ConnectionsAPI.getIncomingConnections()
				.then(result => {
					this.incomingrequests = []
					for (let entry of result) {
						this.incomingrequests.push({
							clientID: entry.clientID,
							CompanyLogo: entry.CompanyLogo,
							name: entry.name,
							Email: entry.Email,
							remove: null
						})
					}
					if (this.$store.state.loading.loading == LoadingState.LOADING)
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_END_LOADING,
							null,
							{ root: true }
						)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		addConnection: function () {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Adding Connection Request",
				{ root: true }
			)
			ConnectionsAPI.addConnection(this.clientID)
				.then(() => {
					this.resetForm()
					this.loadOutgoingItems()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Connection request was sent!",
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		setSendingFalse: function () {
			this.isSending = false
		},
		resetForm() {
			this.loadIncomingItems()
			this.loadOutgoingItems()
			this.$refs.form.reset()
			this.$refs.form2.reset()
		},
		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
		acceptRequest(item) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Adding Connection...",
				{ root: true }
			)
			ConnectionsAPI.addConnection(item.clientID)
				.then(() => {
					this.resetForm()
					this.loadOutgoingItems()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Connection was successfully added!",
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.outgoingrequests.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Removing Connection...",
				{ root: true }
			)

			ConnectionsAPI.deleteConnection(this.itemToDelete.clientID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Connection was successfully removed from the list.",
						{ root: true }
					)
					this.resetForm()
					this.outgoingrequests.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		redeemCode() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Redeeming Invitation Code...",
				{ root: true }
			)
			InvitationCodesAPI.redeem(this.invitationCode)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Invitation Code was successfully redeemed.",
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	},
	computed: {
		...mapState("loading", {
			loading: state => state.loading == LoadingState.LOADING
		})
	},
	watch: {
		selected() {
			this.loadIncomingItems()
			this.loadOutgoingItems()
		}
	}
}
</script>
